// src/layouts/MainLayout.js
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function MainLayout({ children }) {
    return (
        <>
            <Navbar />
                <main className="pt-16 sm:pt-18 md:pt-20">
                    {children}
                </main>
            <Footer />
        </>
    );
}

export default MainLayout;
